module.exports = __webpack_public_path__ + "img/tech_5.a47a3d69.jpg";